import { handleActions, combineActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [combineActions(rawActions.getNlpModels.request)](state, action) {
      return true
    },
    [combineActions(rawActions.getNlpModels.success, rawActions.getNlpModels.failed, rawActions.getNlpModels.cancel)](
      state,
      action
    ) {
      return false
    },
    [rawActions.resetState](state, payload) {
      return defaultState
    },
  },
  defaultState
)
